<template>
  <div class="human-avatar-grid">
    <button v-for="avatar in avatars" :key="String(id(avatar))" type="button" class="human-avatar-card"
      :class="{ active: String(value) === String(id(avatar)) }" :aria-pressed="String(value) === String(id(avatar))"
      @click="$emit('select', id(avatar))">
      <el-image :src="cover(avatar)" fit="cover" class="human-avatar-cover">
        <i slot="error" class="el-icon-picture" />
      </el-image>
      <span v-if="avatar.isSupportRemoveBg" class="human-avatar-badge">可换背景</span>
      <span class="human-avatar-name">{{ avatar.name }}</span>
    </button>
    <p v-if="!avatars.length" class="human-avatar-empty">{{ emptyText }}</p>
  </div>
</template>
<script>
export default {
  name: 'DigitalHumanAvatarGrid',
  props: { avatars: { type: Array, default: () => [] }, value: { default: '' }, emptyText: { type: String, default: '暂无可用形象' } },
  methods: {
    // 同时兼容原数字人页面的数值 ID 和项目 Skill 的规范化 ID，不改变原选择事件的类型。
    id(avatar) { return avatar.personId === undefined ? avatar.id : avatar.personId },
    cover(avatar) {
      const src = avatar.coverUrl || (avatar.figures && avatar.figures[0] && avatar.figures[0].cover) || avatar.picUrl || ''
      try { const url = new URL(src); return url.protocol === 'https:' && !url.username && !url.password ? src : '' } catch (_) { return '' }
    }
  }
}
</script>
<style scoped>
.human-avatar-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:14px}.human-avatar-card{position:relative;border:2px solid #eee;border-radius:9px;background:white;padding:0;overflow:hidden;cursor:pointer;text-align:center}.human-avatar-card.active{border-color:#7564ff;box-shadow:0 0 0 2px #eeeaff}.human-avatar-cover{display:block;height:180px;width:100%;background:#f6f7fb}.human-avatar-name{display:block;padding:10px 6px;color:#303133}.human-avatar-badge{position:absolute;top:6px;left:6px;background:#f0ebff;color:#6751dd;padding:3px;border-radius:4px;font-size:12px}.human-avatar-empty{color:#909399;grid-column:1/-1}
</style>
